import React from 'react';
import PropTypes from 'prop-types';

import { testSetType } from 'types';
import TestSetTab from 'scenes/TestSets/components/TestSetTab';
import TestSetHeaderNav from './components/TestSetHeaderNav';
import TestSetsIntentsSelector from './components/TestSetsIntentsSelector';

import './style.scss';

const TestSetsHeader = ({
  isActive,
  testSets,
  hasSelectedTestSet,
  selectedTestSet,
  onDeselectTestSet,
  executeAnnotator,
  toggleTestSetsList,
}) => (
  <div styleName="header">
    <section styleName="top-layer">
      <TestSetsIntentsSelector
        isActive={isActive}
        toggleTestSetsList={toggleTestSetsList}
      />

      {hasSelectedTestSet && (
        <TestSetHeaderNav
          testSets={testSets}
          executeAnnotator={executeAnnotator}
        />
      )}
    </section>

    <section styleName="tabs">
      {hasSelectedTestSet && (
        <TestSetTab
          selectedTestSet={selectedTestSet}
          deselectTestSet={onDeselectTestSet}
        />
      )}
    </section>
  </div>
);

TestSetsHeader.propTypes = {
  isActive: PropTypes.bool,
  hasSelectedTestSet: PropTypes.bool,
  testSets: PropTypes.arrayOf(testSetType).isRequired,
  selectedTestSet: testSetType.isRequired,
  onDeselectTestSet: PropTypes.func.isRequired,
  toggleTestSetsList: PropTypes.func.isRequired,
  executeAnnotator: PropTypes.func.isRequired,
};

TestSetsHeader.defaultProps = {
  isActive: false,
};

export default TestSetsHeader;
